import * as actionTypes from "../Actions/ChannelActionTypes";
import LogService from "../../CommonSdk/LogService";

const LOG_TAG = "REDUCER:CHANNEL";

const initialState = {
    data: null,
    status: null,
    items: [],
    attachments: [],
    images: [],
    error: {
        errorCode: "",
        errorMessage: ""
    },
    isInProgress: false
};

const clearError = () => {
    return {
        errorCode: "",
        errorMessage: ""
    };
};

const addOrUpdatePublisherList = (newContactList, publisherList) => {
    let updatedPublisherList = [...publisherList];//new list
    newContactList.forEach(element => {
        const foundIndex = updatedPublisherList.findIndex((publisher) => publisher.id === element.id);
        if (foundIndex >= 0) {
            updatedPublisherList[foundIndex] = element;
        } else {
            updatedPublisherList.push(element)
        }
    });
    return updatedPublisherList;
}

const addOrUpdateImageList = (urlList, imagesList) => {
    let updatedImageList = [...imagesList];
    updatedImageList.forEach(element => {
        element.url = "";

        urlList.find(function (post) {
            if (post.url.includes(element.fileName)) {
                element.url = post.url;
            }
        });
    })
    return updatedImageList;
}

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_CHANNEL_PROGRESS:
        case actionTypes.GET_INFORMATION_CHANNEL_PROGRESS:
        case actionTypes.SUBSCRIBE_CHANNEL_PROGRESS:
        case actionTypes.UNSUBSCRIBE_CHANNEL_PROGRESS:
        case actionTypes.GET_ITEMS_CHANNEL_PROGRESS:
        case actionTypes.REFRESH_DATA_CHANNEL_PROGRESS:
        case actionTypes.GET_ATTACHMENTS_CHANNEL_PROGRESS:
        case actionTypes.GET_URL_ATTACHMENTS_PROGRESS:
        case actionTypes.GET_IMAGES_PROGRESS:
        case actionTypes.GET_URL_LIST_PROGRESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Get in progress");
            return {
                ...state,
                isInProgress: true
            };

        case actionTypes.GET_CHANNEL_SUCCESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Get channel retrieved");

            return {
                ...state,
                data: action.payload.data,
                isInProgress: false,
                error: clearError()
            };

        case actionTypes.REFRESH_DATA_CHANNEL_SUCCESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Refresh channel retrieved");

            return {
                ...state,
                data: action.payload.data,
                isInProgress: false,
                error: clearError()
            };

        case actionTypes.GET_INFORMATION_CHANNEL_SUCCESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Get channel retrieved");
            return {
                ...state,
                data: action.payload.data,
                isInProgress: false,
                error: clearError()
            };

        case actionTypes.GET_ITEMS_CHANNEL_SUCCESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Get items Channel retrieved");
            return {
                ...state,
                items: action.payload.items,
                status: action.payload.status,
                isInProgress: false,
                error: clearError()
            };

        case actionTypes.GET_ATTACHMENTS_CHANNEL_SUCCESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Get attachments in the file storages ... ");
            return {
                ...state,
                attachments: action.payload.data,
                isInProgress: false,
                error: clearError()
            }

        case actionTypes.SUBSCRIBE_CHANNEL_SUCCESS:
        case actionTypes.UNSUBSCRIBE_CHANNEL_SUCCESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Subscribe/Unsubscribe retrieved");
            return {
                ...state,
                data: { ...state.data, subscribed: action.payload.status === "subscribed" },
                isInProgress: false,
                error: clearError()
            };

        case actionTypes.GET_URL_ATTACHMENTS_SUCCESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - URL retrieved");
            return {
                ...state,
                isInProgress: false,
                error: clearError()
            }

        case actionTypes.GET_IMAGES_SUCCESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Get images in the file storages ... ");
            return {
                ...state,
                images: action.payload.data,
                isInProgress: false,
                error: clearError()
            }


        case actionTypes.GET_URL_LIST_SUCCESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - All images and URL retrieved");
            const imagesList = addOrUpdateImageList(action.payload.url, state.images);
            return {
                ...state,
                images: imagesList,
                isInProgress: false,
                error: clearError()
            }


        case actionTypes.GET_CHANNEL_ERROR:
        case actionTypes.GET_INFORMATION_CHANNEL_ERROR:
        case actionTypes.SUBSCRIBE_CHANNEL_ERROR:
        case actionTypes.UNSUBSCRIBE_CHANNEL_ERROR:
        case actionTypes.GET_ITEMS_CHANNEL_ERROR:
        case actionTypes.REFRESH_DATA_CHANNEL_ERROR:
        case actionTypes.GET_ATTACHMENTS_CHANNEL_ERROR:
        case actionTypes.GET_URL_ATTACHMENTS_ERROR:
        case actionTypes.GET_IMAGES_ERROR:
        case actionTypes.GET_URL_LIST_ERROR:
            LogService.warn(LOG_TAG, "reduce", "" + action.type + " - Channel not retrieved");

            return {
                ...state,
                error: {
                    errorCode: action.payload.errorCode,
                    errorMessage: action.payload.errorMessage
                },
                isInProgress: false
            };

        case actionTypes.CLEAR_CHANNEL:
            {
                LogService.info(LOG_TAG, "reduce", "" + action.type);

                return {
                    ...initialState
                };
            }

        default:
            return state;
    }
}